export enum Route {
  IconsPage = 'icons-page',
  ErrorPreviewPage = 'error-preview-page',
  LoginPage = 'login-page',
  AssignmentsPage = 'assignments-page',
  AssignmentsSearchPage = 'assignments-search-page',
  ControlPage = 'control-page',
  SearchPage = 'search-page',
  CounterpartiesPage = 'counterparties-page',
  DocumentPage = 'document-page',
  DocumentPrintPage = 'document-print-page',
  CounterpartyPage = 'counterparty-page',
  FileEditorPage = 'file-editor-page',
  ErrorPage = 'error-page',
  FavoriteRedirectPage = 'favorite-redirect-page',
}
